import { Text } from "@/atoms";

type FieldHintProps = {
  readonly hint: string;
  readonly id: string;
};

export default function FieldHint({
  hint,
  id,
}: FieldHintProps): React.ReactElement | null {
  return (
    <div className="flex items-center gap-1 " id={id}>
      <Text
        className="text-secondary"
        component="span"
        text={hint}
        variant="body3"
      />
    </div>
  );
}
